// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.
'use strict'
import { PFixFieldSet } from '../Fields/FieldsImport.js'
import { FieldsFactory } from '../Factory/FieldsFactory.js'
var MarginGroup = function (pfixFieldSet)
{
    PFixFieldSet.call(this, FieldsFactory.MARGIN_GROUP, null, pfixFieldSet)
}

MarginGroup.prototype = Object.create(PFixFieldSet.prototype)

MarginGroup.prototype.getId = function ()
{
    return this.GetValue(FieldsFactory.FIELD_ID)
}

MarginGroup.prototype.setId = function (id)
{
    this.SetField(FieldsFactory.FIELD_ID, id)
}

MarginGroup.prototype.setAccountId = function (accountId)
{
    this.SetField(FieldsFactory.FIELD_ACCOUNT_ID, accountId.toString())
}

MarginGroup.prototype.setTradableInstrumentID = function (insID)
{
    this.SetField(FieldsFactory.FIELD_TRADABLE_INSTRUMENT_ID, insID);
}

MarginGroup.prototype.setRouteId = function (routeId)
{
    this.SetField(FieldsFactory.FIELD_ROUTE_ID, routeId);
}

MarginGroup.prototype.setAmount = function (amount)
{
    this.SetField(FieldsFactory.FIELD_AMOUNT, amount);
}

MarginGroup.prototype.setPrice = function (price)
{
    this.SetField(FieldsFactory.FIELD_PRICE, price);
}

MarginGroup.prototype.setStopPrice = function (price)
{
    this.SetField(FieldsFactory.FIELD_STOP_PRICE, price);
}

MarginGroup.prototype.setOrderType = function (orderType)
{
    this.SetField(FieldsFactory.FIELD_ORDER_TYPE, orderType);
}

MarginGroup.prototype.setOperationMode = function (operationMode)
{
    this.SetField(FieldsFactory.FIELD_OPERATION_MODE, operationMode);
}

MarginGroup.prototype.setMarginMode = function (marginMode)
{
    this.SetField(FieldsFactory.FIELD_MARGIN_MODE, marginMode);
}

MarginGroup.prototype.setProductType = function (productType)
{
    this.SetField(FieldsFactory.FIELD_PRODUCT_TYPE, productType);
}

MarginGroup.prototype.setLeverage = function (setLeverage)
{
    this.SetField(FieldsFactory.FIELD_LEVERAGE_SHORT, setLeverage);
}

export { MarginGroup }